<rt-box variant="default no-padding" layout-vertical>
  <div class="title">
    <rt-heading variant="heading">
      {{ texts.step + ' ' + flowStep().position + ' - ' + stepKindLabel }}
    </rt-heading>
    @if (isEditable()) {
      <rt-icon-button (click)="edit.emit()" iconName="edit" variant="outline" />
    }
  </div>
  <div class="list">
    @for (approval of approvalItems; track trackByUserId($index, approval)) {
      <div class="approval">
        <ng-container *ngTemplateOutlet="approvalTpl; context: { $implicit: approval }" />
      </div>
    }
  </div>
</rt-box>

<ng-template #approvalTpl let-approval>
  <div class="avatar-wrapper">
    @if (approval.user) {
      <rt-avatar
        [type]="approval.user.hasAvatar ? 'image' : 'initials'"
        [imageSrc]="approval.user.photoThumbUrl"
        [initials]="approval.user.initials"
        context="admin"
      />
    }
    @if (!approval.user) {
      <rt-avatar type="icon" iconName="person" size="base" />
    }
  </div>
  <div class="details">
    <div class="name-role">
      @if (approval.user) {
        <span class="name">{{ approval.user.firstName + ' ' + approval.user.lastName }}</span
        ><rt-divider variant="dot" /><span>{{ approval.user.roleName }}</span>
      }
      @if (!approval.user) {
        <span class="name">{{ texts.deletedUser }}</span>
      }
    </div>
    <div class="status">
      <ng-container *ngTemplateOutlet="getStatusTpl(approval); context: { $implicit: approval }" />
    </div>
  </div>
  <div class="actions">
    <ng-container *ngTemplateOutlet="getActionTpl(approval); context: { $implicit: approval }" />
  </div>
</ng-template>

<ng-template #sendReminderTpl let-approval>
  <span
    [rtTooltip]="approval.isRemindDisabled ? texts.reminderBlockedTooltip : null"
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipMaxWidth]="220"
  >
    <rt-button
      [disabled]="approval.isRemindDisabled"
      (click)="approval.decisionId && sendReminder.emit(approval.decisionId)"
      variant="outline"
      >{{ texts.sendReminder }}</rt-button
    >
  </span>
</ng-template>

<ng-template #removeUser let-approval>
  @if (approval.canBeRemoved) {
    <rt-icon-button
      [rtTooltip]="texts.removeDeletedUserTooltip"
      [rtTooltipHasTextAlignCenter]="true"
      [rtTooltipMaxWidth]="220"
      (click)="removeApprover.emit(approval.userId)"
      variant="plain"
      iconName="close"
    />
  }
</ng-template>

<ng-template #statusCanceled>
  {{ approvalStatusTexts.canceled }}
</ng-template>

<ng-template #statusNotRequested>
  {{ approvalStatusTexts.not_requested }}
</ng-template>

<ng-template #statusRequested>
  <rt-icon colorToken="colorIconPrimaryDefault" name="timer-sand" />
  {{ approvalStatusTexts.requested }}
</ng-template>

<ng-template #statusApproved let-approval>
  <rt-icon colorToken="colorIconSuccessDefault" name="done" />
  {{ approvalStatusTexts.approved }}&nbsp;
  <rt-date [time]="approval.statusChangedAt" />
</ng-template>

<ng-template #statusRejected let-approval>
  <div layout-vertical>
    <div layout-horizontal layout-align-items-center>
      <rt-icon colorToken="colorIconCriticalDefault" name="block" />
      {{ approvalStatusTexts.rejected }}&nbsp;
      <rt-date [time]="approval.statusChangedAt" />
    </div>
    <p class="rejection-reason">
      {{ approval.rejectionReason }}
    </p>
  </div>
</ng-template>

<ng-template #statusDeleted>
  @if (context() === FlowStepViewContext.Dialog) {
    <rt-divider variant="dot" />
  }
  <rt-icon colorToken="colorIconCriticalDefault" name="error" />
  {{ texts.deletedUserDescription }}
</ng-template>

<ng-template #statusNoAccess>
  @if (context() === FlowStepViewContext.Dialog) {
    <rt-divider variant="dot" />
  }
  <rt-icon colorToken="colorIconCriticalDefault" name="error" />
  {{ texts.noAccessDescription }}
</ng-template>
